import {
  SubscribeModalShowPricingModal,
  SubscribeModalClosePricingModal,
} from './actions';
import { SubscribeModalMode } from './state';

export const showEducatorModal = (
  canDismiss: boolean
): SubscribeModalShowPricingModal => ({
  type: 'SUBSCRIBE_MODALS_SHOW_PRICING_MODAL',
  planType: 'educator',
  canDismiss,
  mode: 'subscribe',
});

export const closeEducatorModal = (): SubscribeModalClosePricingModal => ({
  type: 'SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL',
  planType: 'educator',
});

export const showPersonalPlanModal = (
  canDismiss: boolean,
  mode: SubscribeModalMode
): SubscribeModalShowPricingModal => ({
  type: 'SUBSCRIBE_MODALS_SHOW_PRICING_MODAL',
  planType: 'personal',
  canDismiss,
  mode,
});

export const closePersonalPlanModal = (): SubscribeModalClosePricingModal => ({
  type: 'SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL',
  planType: 'personal',
});
